"use strict";
/**
 * Customer Enrichment Input Types
 *
 * These types represent the input format for customer-facing enrichment endpoints.
 * They accept multiple LinkedIn identifier formats and basic profile fields.
 *
 * The API will:
 * - Extract/convert identifiers to internal linkedInId format
 * - Determine linkedInIdType based on which identifier was provided
 * - Create/update LNCandidate in the database
 */
Object.defineProperty(exports, "__esModule", { value: true });
